<template>
  <div><slot></slot></div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import {mapGetters, mapState} from 'vuex';

export default {
  props: {
    shipment: {
      type: Object,
      default: () => {},
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    tableData: {
      type: Object,
      default: () => {},
    },
    status: {
      type: String,
      default: '',
    },
    productType: {
      type: String,
      default: '',
    },
  },

  inject: ['container'],

  data() {
    return {};
  },
  computed: {
    hasShipped() {
      return !isEmpty(this.shipment.shipped);
    },

    hasInWarehouse() {
      return !isEmpty(this.orderData[this.productType].notShipped);
    },

    packingSlipNumber() {
      const {packingSlipNumber} = this.shipment;
      return packingSlipNumber ? packingSlipNumber : null;
    },

    packingSlipUrl() {
      if (!this.shipment) {
        return '';
      }

      const {orderNumber, orderCompany} = this.orderData;

      const packingSlipNumber = this.packingSlipNumber;

      const urlParams = new URLSearchParams(window.location.href);

      return `${
        this.encodedContextPath
      }/my-account/packingslip-data/${packingSlipNumber}/pdf/${orderNumber}?ordertype=${urlParams.get(
        'ordertype'
      )}&company=${orderCompany}&pdfView=true&tidyHTML=true`;
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  methods: {
    isEmpty: isEmpty,
  },
};
</script>
